// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  american: (t, data?, options?) => t('enum.dictionary-tag.american.name', data, options),
  british: (t, data?, options?) => t('enum.dictionary-tag.british.name', data, options),
  dated: (t, data?, options?) => t('enum.dictionary-tag.dated.name', data, options),
  formal: (t, data?, options?) => t('enum.dictionary-tag.formal.name', data, options),
  informal: (t, data?, options?) => t('enum.dictionary-tag.informal.name', data, options),
  literary: (t, data?, options?) => t('enum.dictionary-tag.literary.name', data, options),
  offensive: (t, data?, options?) => t('enum.dictionary-tag.offensive.name', data, options),
  slang: (t, data?, options?) => t('enum.dictionary-tag.slang.name', data, options),
  /* eslint-enable max-len */
};
